export default __webpack_public_path__ + "static/apple-bbcd7f8c76893635b4011e75a4a2a144.svg";